import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ManualCreationCargoService } from '../manual-creation-cargo/manual-creation-cargo.service';
import { Catalog } from 'src/app/core/interfaces/catalog';
import { NgxSpinnerService } from 'ngx-spinner';
import { VehicleCargo } from 'src/app/core/interfaces/vehicle-cargo';
import { DatePipe } from '@angular/common';
import { Cargo, CargoRequest } from 'src/app/core/interfaces/cargo';
import { CalculatorMeasurementsComponent } from '../manual-creation-cargo/components/calculator-measurements/calculatorMeasurements.component';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { MatDatepickerInput, MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { ModalEnum } from 'src/app/core/enums/modal.enum';
import { Utils } from 'src/app/core/resources/utils';
import { Tag } from 'src/app/core/interfaces/tag';
import { OptionsAutocomplete } from 'src/app/core/interfaces/optionsAutocomplete';
import { TRIP_TYPES } from 'src/app/core/enums/tripTypes.enum';
import { DateManager } from 'src/app/core/managers/date.manager';
import { Destination } from 'src/app/core/interfaces/destination';
import { Subscription } from 'rxjs';
import { Permission } from 'src/app/core/resources/permission';
import { environmentTypes } from 'src/app/core/resources/typeEnvironment';
import { CargoManager } from 'src/app/core/managers/cargo.manager';
import { AuthService } from 'src/app/core/services/authentication.service';
import { AmountsCargoEnum } from 'src/app/core/enums/amountsCargo.enum';
import { PermissionRole } from 'src/app/core/resources/permission-role';
import { SettingId } from 'src/app/core/interfaces/saas-config';
import { VehicleAlias } from 'src/app/core/interfaces/vehicleAlias';
import { BodyWorkType } from 'src/app/core/interfaces/bodyWorkType';
import { vehicleAxles } from 'src/app/core/resources/vehicleAxles';
import { Company } from 'src/app/core/interfaces/company';

@Component({
  selector: 'app-create-cargo',
  templateUrl: './create-cargo.component.html',
  styleUrls: ['./create-cargo.component.scss']
})
export class CreateCargoComponent implements OnInit {
  permission = Permission;
  vehicleTypeControl: FormControl = new FormControl();
  vehicleAxlesControl: FormControl = new FormControl(null, [Validators.required, Validators.min(2)]);
  bodyworkTypeControl: FormControl = new FormControl();
  trailerBodyworkControl: FormControl = new FormControl();
  trailerAxlesControl: FormControl = new FormControl(null, [Validators.min(2)]);
  companyControl: FormControl = new FormControl('', Validators.required);
  transportCompanyControl: FormControl = new FormControl(null);
  form: FormGroup;
  tags: Tag[] = [];
  vehicleAliases: VehicleAlias[] = [];
  tagControl: FormControl;
  vehicleAliasControl: FormControl = new FormControl();
  readonly tripTypes: { label: string, value: TRIP_TYPES }[] = [
    { label: "Importación", value: TRIP_TYPES.IMPORT },
    { label: "Exportación", value: TRIP_TYPES.EXPORT },
    { label: "Nacional", value: TRIP_TYPES.NATIONAL },
    { label: "Urbana", value: TRIP_TYPES.URBAN },
    { label: "Última milla/ Paqueteo urbano", value: TRIP_TYPES.LAST_MILE }
  ];
  tripTypesEnabled: { label: string, value: TRIP_TYPES }[];

  readonly loadDateOptions = { min: new Date(), max: DateManager.add(new Date(), 30, 'days') };
  optionsCompany = {
    title: 'Contratante del servicio',
    disableCompanyIfInactive: true,
    optionAll: false,
    appearance: 'outline'
  };
  originCityOptions = {
    title: 'Origen (Municipio o Ciudad)',
    appearance: 'outline'
  };
  destinationCityOptions = {
    title: 'Destino (Municipio o Ciudad)',
    appearance: 'outline'
  }
  optionsTypeVehicle: OptionsAutocomplete = {
    showAutocomplete: true
  };
  optionsBodyworkType: OptionsAutocomplete = {
    title: 'Tipo de carrocería'
  }
  vehicleWeights: { [key: string]: { id: string, weight?: number } } = {};
  vehicleAxles: { [key: string]: { id: string, axles?: number } } = {};
  maxWeightAllowed: number = AmountsCargoEnum.MAX_WEIGHT_ALLOWED_KG;
  formValidate = '';
  minCost: number = 1;
  endDateOptions: { min: Date }[];
  subscriptions: Subscription = new Subscription();
  environmentTypes: string[] = environmentTypes;
  constructor(
    private manualCreationCargoService: ManualCreationCargoService,
    private spinner: NgxSpinnerService,
    public datePipe: DatePipe,
    public dialogMaterial: MatDialog,
    public utils: Utils,
    private cargoManager: CargoManager,
    private authService: AuthService,
    private permissionRole: PermissionRole
  ) { }

  ngOnInit() {
    const hasOwnFleet = this.authService && this.authService.hasCompanySettingEnabled(SettingId.OWN_FLEET);
    const hasPermissionFreightCostZero = this.permissionRole.hasPermission(
      this.permission.cargo.module,
      this.permission.cargo.createCargoWithRateOrCostZero
    );
    if (hasOwnFleet || hasPermissionFreightCostZero) this.minCost = 0;
    if (this.hasTransportServicesCompany) { this.transportCompanyControl.setValidators(Validators.required); }
    this.initForm();
    this.getTags();
    this.getVehicleAliases();
    this.setSubscriptions();
  }

  private initForm() {
    this.form = new FormGroup({
      ministry: new FormControl(true, Validators.required),
      doc: new FormControl(),
      tripType: new FormControl(null, [Validators.required]),
      origin: new FormControl(null, [Validators.required]),
      dateLoad: new FormControl(new Date(), [Validators.required]),
      destinations: new FormArray([
        new FormGroup({
          destination: new FormControl(null, [Validators.required]),
          downloadDate: new FormControl(),
        })
      ]),
      quantity: new FormControl(1, [Validators.required, Validators.min(1)]),
      refrigerated: new FormControl(),
      zone: new FormControl(this.authService.hasCompanySettingEnabled(SettingId.CREATE_SERVICE_PUBLIC_BY_DEFAULT) ? 'public' : 'private'),
      quality: new FormControl('Seco'),
      unit: new FormControl('1'),
      observation: new FormControl(),
      observationDriver: new FormControl(),
      cost: new FormControl(null, [Validators.required, Validators.min(this.minCost)]),
      weight: new FormControl(null, [Validators.min(1), Validators.max(this.maxWeightAllowed)]),
      measurements: new FormControl(null, Validators.min(0.0001)),
      labels: new FormControl([])
    });
    this.tripTypesEnabled = this.utils.clone(this.tripTypes);
    this.tagControl = new FormControl('');
    this.vehicleAliasControl = new FormControl('');
    this.vehicleTypeControl = new FormControl('', Validators.required);
    this.vehicleAxlesControl = new FormControl(null, Validators.required);
    this.bodyworkTypeControl = new FormControl('', Validators.required);
    this.trailerBodyworkControl = new FormControl('');
    this.trailerAxlesControl = new FormControl('');
    this.endDateOptions = [{
      min: new Date()
    }];
    this.companyControl.setValue(null);
    this.optionsCompany['initialNit'] = '';
    this.optionsCompany['initialValue'] = '';
    this.optionsCompany = { ...this.optionsCompany };
    this.originCityOptions['initialValue'] = '';
    this.originCityOptions = { ...this.originCityOptions };
    this.destinationCityOptions['initialValue'] = '';
    this.destinationCityOptions = { ...this.destinationCityOptions };
    this.optionsTypeVehicle['initialValue'] = '';
    this.optionsTypeVehicle = { ...this.optionsTypeVehicle };
    this.optionsBodyworkType['initialValue'] = '';
    this.optionsBodyworkType = { ...this.optionsBodyworkType };
  }

  private setSubscriptions() {
    this.subscriptions.add(this.companyControl.valueChanges.subscribe(company => this.setDefaultTransportCompany(company)));
    this.subscriptions.add(this.form.get('origin').valueChanges.subscribe(() => this.checkTripTypes()));
    this.subscriptions.add(this.destinations.valueChanges.subscribe(() => this.checkTripTypes()));
    this.subscriptions.add(this.vehicleTypeControl.valueChanges.subscribe((vehicle: VehicleCargo) => this.updateVehicleType(vehicle)));
    this.subscriptions.add(this.bodyworkTypeControl.valueChanges.subscribe(() => this.updateBodyworkType()));
  }

  private setDefaultTransportCompany(company: any): void {
    this.transportCompanyControl.setValue(company && company.transportCompany ? company.transportCompany : null);
  }

  private getTags(): void {
    this.manualCreationCargoService.getLabelTags().subscribe(
      (success) => {
        if (success && success.length) this.tags = success;
        else this.tags = [];
      }, () => {
        this.tags = [];
      }
    )
  }

  private getVehicleAliases(): void {
    this.manualCreationCargoService.getVehicleAliases().subscribe(
      (success) => this.vehicleAliases = success && success.length ? success.sort((a, b) => a.name.localeCompare(b.name)) : [],
      () => this.vehicleAliases = []
    );
  }

  private async getVehicleWeight(vehicle: VehicleCargo) {
    if (this.vehicleWeights[vehicle.name] && this.vehicleWeights[vehicle.name].weight)
      return this.vehicleWeights[vehicle.name].weight;
    let infoVehicle: { id: string, name: string, weight: number };
    try { infoVehicle = await this.manualCreationCargoService.getVehicleWeightById(vehicle.id).toPromise(); } catch (error) { }
    const weight = infoVehicle && infoVehicle.weight ? infoVehicle.weight : AmountsCargoEnum.MAX_WEIGHT_ALLOWED_KG;
    this.maxWeightAllowed = weight;
    this.vehicleWeights[vehicle.name] = { id: vehicle.id, weight };
    return weight;
  }

  private checkTripTypes() {
    const originCity: { id: string, name: string } = this.form.get('origin').value;
    const destinationCities: { id: string, name: string }[] = this.destinations.value.map(destination => destination.destination);
    if (!originCity || !originCity.name || !destinationCities.every(city => !!city && !!city.name)) {
      this.tripTypesEnabled = this.utils.clone(this.tripTypes);
      return;
    }
    if (destinationCities.every(city => city.name === originCity.name))
      this.tripTypesEnabled = [
        { label: "Importación", value: TRIP_TYPES.IMPORT },
        { label: "Exportación", value: TRIP_TYPES.EXPORT },
        { label: "Urbana", value: TRIP_TYPES.URBAN },
        { label: "Última milla/ Paqueteo urbano", value: TRIP_TYPES.LAST_MILE }
      ];
    else
      this.tripTypesEnabled = [
        { label: "Importación", value: TRIP_TYPES.IMPORT },
        { label: "Exportación", value: TRIP_TYPES.EXPORT },
        { label: "Nacional", value: TRIP_TYPES.NATIONAL }
      ];

    if (!this.tripTypesEnabled.some(type => type.value === this.form.get('tripType').value))
      this.form.get('tripType').setValue(null);
  }

  selectVehicleAlias(event: MatSelectChange): void {
    const selectedAlias: VehicleAlias = event.value;
    if (selectedAlias) {
      this.vehicleTypeControl.setValue(selectedAlias.vehicleType);
      this.optionsTypeVehicle['initialValue'] = selectedAlias.vehicleType.name;
      this.optionsTypeVehicle = { ...this.optionsTypeVehicle };
      this.vehicleAxlesControl.setValue(selectedAlias.axles);
    }
  }

  private async updateVehicleType(vehicle: VehicleCargo) {
    if (vehicle && vehicle.id)
      this.optionsBodyworkType['initialVehicleTypeId'] = vehicle.id;
    this.optionsBodyworkType['initialValue'] = '';
    this.optionsBodyworkType = { ...this.optionsBodyworkType };
    this.bodyworkTypeControl.setValue('');
    if (vehicle && vehicle.id) {
      const maxWeight = await this.getVehicleWeight(vehicle);
      this.form.get('weight').setValidators([Validators.min(1), Validators.max(maxWeight)]);
      this.form.get('weight').updateValueAndValidity();
      if (vehicleAxles[vehicle.name])
        this.vehicleAxlesControl.setValue(vehicleAxles[vehicle.name]);
      const vehicleAlias: VehicleAlias = this.vehicleAliasControl.value;
      if (vehicleAlias && vehicleAlias.vehicleType && vehicleAlias.vehicleType.name !== vehicle.name)
        this.vehicleAliasControl.setValue(null);
    } else this.vehicleAxlesControl.setValue(null);
  }

  get showAxlesControl(): boolean {
    const vehicleTypeName = this.utils.getNestedValue(this.vehicleTypeControl.value, 'name');
    return vehicleTypeName && !vehicleAxles[vehicleTypeName];
  }
  updateVehicleAxles(event: Event): void {
    const value: number = parseInt((event.target as HTMLInputElement).value);
    const vehicleAlias: VehicleAlias = this.vehicleAliasControl.value;
    if (vehicleAlias && vehicleAlias.axles !== value)
      this.vehicleAliasControl.setValue(null);
  }
  private updateBodyworkType() {
    this.trailerBodyworkControl.setValue(null);
    this.trailerAxlesControl.setValue(null);
  }
  get showTrailerInfo(): boolean {
    const vehicleTypeName = this.utils.getNestedValue(this.vehicleTypeControl.value, 'name');
    const bodyworkTypeName = this.utils.getNestedValue(this.bodyworkTypeControl.value, 'name');
    return vehicleTypeName && vehicleTypeName === 'TRACTOCAMION' && bodyworkTypeName && bodyworkTypeName !== 'GRUA';
  }

  selectTag(event: MatSelectChange): void {
    const selectedTag: string = event.value;
    const labels: string[] = this.form.get('labels').value;
    if (!labels.includes(selectedTag)) {
      labels.push(selectedTag);
      this.form.patchValue({ labels });
    }
    this.tagControl.setValue(null);
  }
  clearTag(index: number): void {
    const labels: string[] = this.form.get('labels').value;
    if (labels.length > index) {
      labels.splice(index, 1);
      this.form.patchValue({ labels });
    }
  }

  get destinations(): FormArray {
    return this.form.get('destinations') as FormArray;
  }
  addDestination(): void {
    this.destinations.push(new FormGroup({
      destination: new FormControl(null, [Validators.required]),
      downloadDate: new FormControl(),
    }));
    this.endDateOptions.push({ min: new Date() });
    this.updateDestinationDates();
  }
  deleteDestination(index: number): void {
    this.destinations.removeAt(index);
    this.endDateOptions.splice(index, 1);
    this.updateDestinationDates();
  }
  updateDestinationDates() {
    let minDate: Date = new Date();
    if (this.form.get('dateLoad').value)
      minDate = new Date(this.form.get('dateLoad').value);
    this.destinations.controls.forEach((destination, index) => {
      this.endDateOptions[index].min = minDate;
      const downloadDate: Date = destination.get('downloadDate').value;
      if (downloadDate) {
        if (DateManager.isBefore(downloadDate, minDate))
          destination.get('downloadDate').setValue(minDate);
        else
          minDate = downloadDate;
      }
    })
  }

  openDialogCalculatorMeasurements() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialogMaterial.open(CalculatorMeasurementsComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(totalSize => {
      if (totalSize)
        this.form.get('measurements').setValue(totalSize);
    });
  }

  get hasTransportServicesCompany(): boolean {
    return !!(this.authService && this.authService.hasTransportServicesCompany);
  }

  get isEnableToCreateCargo(): boolean {
    return this.form.valid && this.vehicleTypeControl.valid && this.bodyworkTypeControl.valid &&
      this.companyControl.valid && this.transportCompanyControl.valid;
  }

  private checkCustomValidations(): { isValid: boolean } {
    if (this.utils.errorMessagesCustomized(this.companyControl, 'contratante del servicio')) return { isValid: false };
    if (this.utils.errorMessagesCustomized(this.transportCompanyControl, 'empresa de transporte')) return { isValid: false };
    if (this.utils.errorMessagesCustomized(this.form.get('origin'), 'origen')) return { isValid: false };
    for (let i = 0; i < this.destinations.controls.length; i++) {
      const control = this.destinations.controls[i];
      if (this.utils.errorMessagesCustomized(control.get('destination'), `destino ${i + 1}`)) return { isValid: false };
    }
    if (this.utils.errorMessagesCustomized(this.form.get('tripType'), 'tipo de viaje')) return { isValid: false };
    if (this.utils.errorMessagesCustomized(this.form.get('quantity'), 'vehículos', null, null, 1)) return { isValid: false };
    if (this.utils.errorMessagesCustomized(this.vehicleTypeControl, 'tipo de vehículo')) return { isValid: false };
    if (this.showAxlesControl && this.utils.errorMessagesCustomized(this.vehicleAxlesControl, 'número de ejes', null, null, 2)) return { isValid: false };
    if (this.utils.errorMessagesCustomized(this.bodyworkTypeControl, 'tipo de carrocería')) return { isValid: false };
    if (this.showTrailerInfo && this.utils.errorMessagesCustomized(this.trailerBodyworkControl, 'tipo de carrocería del tráiler')) return { isValid: false };
    if (this.showTrailerInfo && this.utils.errorMessagesCustomized(this.trailerAxlesControl, 'número de ejes del tráiler', null, null, 2)) return { isValid: false };
    if (this.utils.errorMessagesCustomized(this.form.get('cost'), 'flete', null, null, this.minCost)) return { isValid: false };
    return { isValid: true };
  }


  createCargo(): void {
    if (!this.checkCustomValidations().isValid) return;
    const dateLoad = this.datePipe.transform(this.form.get('dateLoad').value, 'yyyy-MM-dd HH:mm Z', 'UTC');
    const ministry = this.form.get('ministry').value;
    const company: Company = this.companyControl.value;
    const expirationBillDays: number = this.utils.getNestedValue(company, 'billingConfiguration.expirationDays');
    const cargo: CargoRequest = {
      dateLoad,
      numberDocumentCreatorLoad: this.authService.getUserSession().information.document.toString(),
      createdBy: {
        userId: this.authService.getUserSession().information.document,
        userName: this.authService.getUserSession().information.name,
        date: DateManager.dateToString(new Date()),
      },
      prevalidation: { valid: false },
      requiresPreBill: !!this.utils.getNestedValue(company, 'billingConfiguration.requiresPreInvoice'),
      idCompany: company.companyId,
      ministry: ministry,
      numberDocumentSender: this.form.get('doc').value,
      labels: this.form.get('labels').value,
      cargoModel: {
        tripType: this.form.get('tripType').value
      },
      axles: this.showAxlesControl ? Number(this.vehicleAxlesControl.value) : null,
      cargoFeature: {
        productType: {
          code: null,
          name: null,
          type: null,
          description: null
        },
        vehicleType: {
          name: this.vehicleTypeControl.value.name,
          quantity: 1,
          bodyWorkType: {
            name: this.bodyworkTypeControl.value.name,
          },
          vehicleAlias: this.vehicleAliasControl.value ? this.vehicleAliasControl.value.name : null,
          trailer: {
            bodywork: this.trailerBodyworkControl.value && this.trailerBodyworkControl.value.name ? this.trailerBodyworkControl.value.name : null,
            axles: this.trailerAxlesControl.value ? Number(this.trailerAxlesControl.value) : null,
          },
          quality: ''
        },
        uploadDownload: {
          origin: {
            name: this.form.get('origin').value.name,
            municipalityCode: this.form.get('origin').value.id,
            addresses: []
          },
          destination: []
        },
        cargoMeasure: {
          quantity: null,
          totalMeasurement: parseFloat(this.form.get('measurements').value),
          totalWeigth: parseInt(this.form.get('weight').value),
          amount: null,
          unit: this.form.get('weight').value && this.form.get('unit').value ? this.form.get('unit').value : null
        }
      },
      shippingCost: {
        totalCost: this.form.get('cost').value,
        freightCost: this.form.get('cost').value,
        paymentTime: 30,
        expirationBillDays: expirationBillDays ? expirationBillDays : 1
      },
      observation: this.form.get('observation').value,
      observationDriver: this.form.get('observationDriver').value,
      zone: this.form.get('zone').value
    };
    const destinations: Destination[] = this.destinations.value.map((destination, i) => {
      return {
        id: `${i}`,
        name: destination.destination.name,
        municipalityCode: destination.destination.id,
        addresses: [],
        downloadDate: this.datePipe.transform(destination.downloadDate, 'yyyy-MM-dd HH:mm Z', 'UTC')
      }
    });
    cargo.cargoFeature.uploadDownload.destination = destinations;
    if (this.hasTransportServicesCompany) { cargo.transportCompany = this.transportCompanyControl.value; }
    if (ministry) {
      cargo['cargoOwner'] = {
        documentNumber: company.companyId,
        documentType: '3',
        name: company.name
      }
      cargo['monitoringCompany'] = {
        id: '9017835729',
        name: 'Innovbo sas'
      }
    }

    let cargoList: CargoRequest[] = [];
    for (let vehicle = 0; vehicle < parseInt(this.form.get('quantity').value); vehicle++) {
      cargoList.push(cargo)
    }
    this.spinner.show();
    this.manualCreationCargoService.createRequestCargo(cargoList).subscribe(
      {
        next: async (success: Cargo[]) => {
          this.spinner.hide();
          await this.cargoManager.modalCargoCreation(success, `Tu solicitud de servicio ha sido creada con los siguientes consecutivos`);
          this.initForm();
        },
        error: (error) => {
          this.spinner.hide();
          this.manualCreationCargoService.showResponseCreateCargo(
            'Ocurrió un error al crear la solicitud de servicio',
            error
          );
        },
      }
    );
  }

  ngOnDestroy() {
    if (this.subscriptions) this.subscriptions.unsubscribe();
  }

}
